
import { serverApi } from '../../core';

import { Log } from '../../core';
let log = Log.getLogger('MultiSceneForApp.search.server.search');

function getDataModelDefinition(token, projectId, debug, callback) {
    serverApi.callGet({
        module: 'data',
        name: 'getDataModelDefinition',
        token: token,
        params: [
            ['project', projectId],
            ['debug', debug]
        ],
        callback: (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`data.server.data.getDataModelDefinition() failed`);
                }
                callback(
                    err,
                    (response && response.dataModelDefinition) ? response.dataModelDefinition : null
                );
            }
        }
    });
}

function execDocument(token, projectId, operation, objectKey, params, clientOptions, debug, callback) {
    let clientDesc = clientOptions ? clientOptions.desc : '';
    serverApi.callPost({
        module: 'data',
        name: 'execDocument',
        token: token,
        body: {
            projectId,
            operation,
            objectKey,
            params,
            clientDesc,
            debug
        },
        callback: (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`data.server.data.execDocument() failed`);
                }
                callback(
                    err,
                    (response && response.result) ? response.result : null
                );
            }
        }
    });
}

function execOperation(token, projectId, operation, dataModelItemId, params, clientOptions, debug, callback) {
    let clientDesc = clientOptions ? clientOptions.desc : '';
    serverApi.callPost({
        module: 'data',
        name: 'execOperation',
        token: token,
        body: {
            projectId,
            operation,
            dataModelItemId,
            params,
            clientDesc,
            debug
        },
        callback: (err, response) => {
            if (callback) {
                if (err) {
                    log.warn(`data.server.data.execOperation() failed`);
                }
                callback(
                    err,
                    (response && response.result) ? response.result : null
                );
            }
        }
    });
}

export {
    execDocument,
    execOperation,
    getDataModelDefinition
};
